import HTTP from "../../utility/http";
import { asyncHandler } from "@/utility/async";

const state = {
  users: [],
  outfitters: [],
  showDeletedOutfitters: 0,
  showDeletedUsers: 0,
};

const getters = {
  getUsers: (state) => state.users,
  getOutfitters: (state) => state.outfitters,
  getShowDeletedOutfitters: (state) => state.showDeletedOutfitters,
  getShowDeletedUsers: (state) => state.showDeletedUsers,
};

const actions = {
  async save_outfitter({ commit }, data) {
    const resp = await asyncHandler(
      HTTP({ url: "admin/save-outfitter", method: "POST", data })
    );
    if (resp.success) {
      commit("set_outfitter", resp.outfitter);
    }
    return resp;
  },

  async restore_outfitter(context, id) {
    return await asyncHandler(
      HTTP({ url: "admin/restore-outfitter/" + id, method: "GET" })
    );
  },

  async delete_outfitter({ commit }, id) {
    const resp = await asyncHandler(
      HTTP({ url: "admin/delete-outfitter/" + id, method: "GET" })
    );
    if (resp.success) {
      commit("delete_outfitter", resp.id);
    }
    return resp;
  },

  async load_outfitters({ commit, state }) {
    const resp = await asyncHandler(
      HTTP({
        url: "admin/get-outfitters/" + state.showDeletedOutfitters,
        method: "GET",
      })
    );
    if (resp.success) {
      commit("set_outfitters", resp.outfitters);
    }
    return resp;
  },
};

const mutations = {
  delete_outfitter: (state, id) => {
    state.outfitters.splice(
      state.outfitters.findIndex((e) => e.id == id),
      1
    );
  },
  delete_user: (state, id) => {
    state.users.splice(
      state.users.findIndex((e) => e.id == id),
      1
    );
  },
  set_show_deleted_users: (state, val) => {
    state.showDeletedUsers = val;
  },
  set_show_deleted_outfitters: (state, val) => {
    state.showDeletedOutfitters = val;
  },
  set_outfitter: (state, outfitter) => {
    const index = state.outfitters.findIndex((e) => e.id == outfitter.id);
    if (index !== -1) {
      state.outfitters.splice(index, 1);
    }
    state.outfitters.push(outfitter);
  },
  set_user: (state, user) => {
    const index = state.users.findIndex((e) => e.id == user.id);
    if (index !== -1) {
      state.users.splice(index, 1);
    }
    state.users.push(user);
  },
  set_users: (state, users) => {
    state.users = users;
  },
  set_outfitters: (state, outfitters) => {
    state.outfitters = outfitters;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
